<template>
	<transition name="el-fade-in-linear">
    <div v-show="transitionshow">  
    	<!------------------------Percent search start (提成搜索开始)---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        	<el-form-item ref="percent" :model="percent">
            	<el-input placeholder="请输入关键字" v-model="percent.key" ></el-input>
          	</el-form-item>
          	<el-form-item>
            	<el-button type="primary" icon="el-icon-search" @click="percentsearch">查询</el-button>
          	</el-form-item>
          	<el-form-item v-if="actionauth.base_percent_add=='true'">
            	<el-button type="primary" icon="el-icon-circle-plus-outline"  @click="addpercentsetting">新增提成设置</el-button>
          	</el-form-item>
        </el-form>
        <!------------------------Percent search end (提成搜索结束)---------------------->
        
        <!------------------------Percent lists start (提成列表主体开始)------------------->
        <div class="backborder2" style="margin-top:10px">
	        <el-table :data="percentlists" v-loading="plLoading">
	          	<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="time" label="有效期" width="210" align="center"></el-table-column>
				<el-table-column prop="managername" label="创建人" width="120" align="center"></el-table-column>
	          	<el-table-column label="操作" width="150" align="center" v-if="actionauth.base_percent_edit=='true' || actionauth.base_percent_del=='true'">
	          		<template slot-scope="scope">
	            		<el-button type="primary" size="small" circle icon="el-icon-edit" @click="editpercent(scope.row)" v-if="actionauth.base_percent_edit=='true'"></el-button>
	            		<el-button type="danger" size="small" circle icon="el-icon-delete" @click="deletepercent(scope.row)" v-if="actionauth.base_percent_del=='true'"></el-button>
	          		</template>
	          	</el-table-column>
	        </el-table>
	        <div class="block">
	        <!--分页开始-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="percent.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="percent.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	          <!--分页结束-->
	        </div>
        </div>
        <!------------------------Percent lists end (提成列表主体结束)------------------->
        
        <!------------------------add Percent start (添加提成设置开始)------------------->
        <el-dialog title="新增提成设置" :visible.sync="createPercent" label-width="100px" top="2vh">
        	<el-form ref="pct" :model="lists" :rules="pct" size="medium">
            	<el-col :span="23">
              		<el-form-item label="名称：" prop="name" label-width="11%" text-align="left">
              			<el-input v-model="lists.name" label-width="85%"></el-input>
              		</el-form-item>
              	</el-col>
              	<el-col :span="23">
              		<el-form-item label="适合用户：" prop="type">
              			<el-checkbox v-for="(item,index) in lists.type" v-model="item.status" :key="index">{{item.name}}</el-checkbox>               		
              		</el-form-item>
            	</el-col>
				
				<!------ 提成制度 --------->
              	<el-col :span="23">
              		<el-form-item label="提成制度">
              			<el-table :data="ticheng" border style="width: 100%">
              				<el-table-column prop="id" label="编号" width="60"></el-table-column>
                			<el-table-column label="价格下限（元）" align="center">
                  				<template slot-scope="scope">
                  					<el-input v-model="lists.min_price[scope.$index]" placeholder="请填写商品价格下限"></el-input>
                  				</template>
                			</el-table-column>
                			<el-table-column label="价格上限（元）" align="center">
                  				<template slot-scope="scope">
                  					<el-input v-model="lists.max_price[scope.$index]" placeholder="请填写商品价格上限"></el-input>
                  				</template>
                			</el-table-column>
                			<el-table-column label="提成百分比（%）" align="center">
                  				<template slot-scope="scope">
                  					<el-input v-model="lists.percent[scope.$index]" placeholder="请填写提成百分比"></el-input>
                  				</template>
                			</el-table-column>
                			<el-table-column label="操作" width="70" align="center">
                  				<template slot-scope="scope">
                  					<el-button type="primary" size="mini" icon="el-icon-plus" v-if="scope.row.id==1" @click="addpercent"></el-button>
                  					<el-button type="danger" size="mini" icon="el-icon-minus" v-if="scope.row.id>1" @click="delpercent(scope.$index)"></el-button>
                  				</template>
                			</el-table-column>
              			</el-table>
              		</el-form-item>
              	</el-col>
              	
              	<!----- 选择商品 ------>
              	<el-col :span="23">
              		<el-form-item>
                		<el-button type="primary" icon="el-icon-circle-plus-outline"  @click="selectgoods">选择使用产品</el-button>
                	</el-form-item>
                	<el-form-item>
                		<el-table :data="tempgoods" style="width: 100%">
                			<el-table-column prop="name" label="商品名称" width="240"></el-table-column>
                			<el-table-column prop="brandname" label="品牌" width="155"></el-table-column>
                			<el-table-column prop="spec" label="批发价（元）" width="140"></el-table-column>
                			<el-table-column label="操作" width="70" align="center">
                  			<template slot-scope="scope">
                  				<el-button type="danger" size="mini" icon="el-icon-minus" v-if="scope.row.id>1" @click="deltempgoods(scope.row)"></el-button>
                  			</template>
                			</el-table-column>
                		</el-table>
                	</el-form-item>
              	</el-col>
          	</el-form>
          	<div slot="footer" class="dialog-footer">
            	<el-button size="medium" @click="createPercent = false">取 消</el-button>
            	<el-button size="medium" type="primary" :loading="createLoading" v-if="lists.click==='createPercentSave'" @click="createPercentSave">保 存</el-button>
            	<el-button size="medium" type="primary" :loading="createLoading" v-if="lists.click==='editPercentSave'" @click="editPercentSave">保 存</el-button>
          	</div>
        </el-dialog>    
        <!------------------------add Percent end (添加提成设置结束)--------------------->
        
        <!------------------------select goods start (选择适用产品开始)------------------>
        <el-dialog title="选择产品" :visible.sync="opengoods" width="60%" top="2vh">
        	<!------ 产品搜索 ------>
        	<el-form :inline="true" class="demo-form-inline">
        	    <el-form-item>
              		<el-select v-model="searchgoods.brandid" clearable filterable placeholder="按品牌">
              			<el-option label="不选品牌" value=""></el-option>
                		<el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
              		</el-select>
            	</el-form-item>
        		<el-form-item ref="searchgoods" :model="searchgoods">
            		<el-input placeholder="请输入关键字" size="35" v-model="searchgoods.key" clearable @keyup.enter.native="getgoods"></el-input>
          		</el-form-item>
          		<el-form-item>
            		<el-button type="primary" icon="el-icon-search" @click="getgoods">查询</el-button>
          		</el-form-item>
        	</el-form>
        	<!----- 商品列表 ----->
        	<el-table :data="goodslists" v-loading="goodsLoading" style="width:100%" @selection-change="selectids">
        		<el-table-column type="selection"></el-table-column>
            	<el-table-column label="名称" prop="name"></el-table-column>
            	<el-table-column label="品牌" prop="brandname"></el-table-column>
            	<el-table-column label="规格" prop="spec"></el-table-column>
        	</el-table>
        	<!-----------------分页开始-------------------->
          	<div class="block">
            	<el-pagination 
              		@size-change="goodspageSizeChange" 
          	  		@current-change="goodspageCurrentChange"
          	  		:current-page="searchgoods.p"
          	  		:page-sizes="[10, 20, 50]"
          	  		:page-size="searchgoods.rollpage"
          	  		layout="total, sizes, prev, pager, next, jumper"
          	  		:total="goods_total_rows">
        		</el-pagination>
          	</div>
        </el-dialog>
        <!------------------------select goods end (选择适用产品结束)-------------------->
                      
	</div>
	</transition>
</template>

<script>
export default {
  data () {
    return {
      actionauth:'', //操作功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Percent/index",
      
      plLoading:false, 	   //提成列表预加载开关
      goodsLoading:false,  //查询商品列表页预加载开关
      createPercent:false, //新增提成设置页面开关
      isopen:false,		   //开启选择开关
      opengoods:false,	   //使用商品开启开关
      total_rows:0,        //提成列表总额
      goods_total_rows:0,  //商品列表总数
      addpercentnumber:1,  //提成制度编号
      createLoading: false,
      numb:0,
      
      percent:{ //提成列表数组
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, //每页条数
        p: 1
      },
      lists: { //添加提成数组
        act:'addpercent',
        click:'createPercentSave',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
     	detail:[],
        type:[false,false,false],
        goods:[],
        goods_ids:'',
        min_price:[],
        max_price:[],
        percent:[]
      },
      searchgoods: { //搜索使用商品数组
      	act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10,
        p: 1
      },
      percentlists:[],   //提成列表数据
      statuslists:[],    //状态开关
      ticheng:[{id:1}],  //提成数组
      tempgoods:[],      //临时存储选中商品数组
      brandlists:[],	 //品牌数组
      goodslists:[],	 //选择页商品数组列表
      editgoods:[],
      
      pct: {
        name: [
            { required: true, message: '请输入提成设置名称', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字符'}
        ],
        type: [
        	{ type: 'array', required: true, message: '请至少选择一个适合用户', trigger: 'change' }
        ],
      },
      
      selectproduct:[],
      
    }
  },
  mounted(){
    this.getactionauth();
    this.percentsearch();
  },
  methods:{
  
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  	
    /** 重置表单 */
    reset() {
      this.$refs.create.resetFields();
    },
    
    /** 搜索提成列表 */
    percentsearch() { 
      this.plLoading = true; //开启提成预加载动画
      var resource = this.$resource(this.url);
      resource.query(this.percent).then((res) => {
      	if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login');
            this.plLoading = false; //关闭加载动画
          }
          this.$message.error(res.data.Message);
          this.plLoading = false; //关闭加载动画
        }else{
          const _this=this;
          this.percentlists = JSON.parse(Base64.decode(res.data.Data));
          this.percentlists.forEach(function(e,index){ //更新提成列表状态信息
            if(e.status==0){
              _this.statuslists.splice(index,1,false);
            }else{
              _this.statuslists.splice(index,1,true);
            }
          });
          this.total_rows=parseInt(res.data.count);
          this.plLoading = false; //关闭加载动画
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.plLoading = false; //关闭加载动画
      });
    },
    
    /** 是否上架开关 */
    changeGrounding(i,item) { 
    	if(this.statuslists[i]){
        	var isstatus=1;
      	}else{
        	var isstatus=0;
      	}
        var resource = this.$resource(this.url);
        resource.save({act:'changestatus',id:item.id,status:isstatus,token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
            	this.$message.error(res.data.Message);
          	}
      	}).catch((res) => {
          	this.$message.error(this.GLOBAL.errortext);
      	});
    },
    
    /** 搜索提成分页 */
    pageSizeChange(val) {
        this.percent.rollpage = val;
        this.percentsearch();
    },
    /** 搜索提成分页 */
    pageCurrentChange(val) {
        this.percent.p = val;
        this.percentsearch();
    },
    /** 商品搜索分页 */
    goodspageSizeChange(val) {
        this.searchgoods.rollpage = val;
        this.getgoods();
    },
    /** 商品搜索分页 */
    goodspageCurrentChange(val) {
        this.searchgoods.p = val;
        this.getgoods();
    },
    /** 添加提成价格设置 */
    addpercent() {
    	this.addpercentnumber++;
    	this.ticheng.push({id:this.addpercentnumber});
    },
    /** 删除提成价格设置 */
    delpercent(i) {
    	this.ticheng.splice(i,1);
    	this.lists.min_price.splice(i,1);
    	this.lists.max_price.splice(i,1);
    	this.lists.percent.splice(i,1);
    },
    /** 选择适用商品 */
    selectgoods() {
    	this.opengoods=true;
    	this.getBrand(); //获取品牌列表
    	this.getgoods(); //获取商品列表
    },
    
    /** 检测是否添加产品 */
    changegoods(obj) {
    	const oid=obj.id;
    	const _this=this;
     	this.isopen=true;
     	if(this.lists.goods!='') {
     		this.lists.goods.forEach(function(id,i) {
    			if(oid==id) {
    				_this.isopen=false;
    				return false;
    			}
    		});
     	}
    	if(this.isopen==true) {
    		this.lists.goods.push(obj.id);
    		this.tempgoods.push({id:obj.id,name:obj.name,brandname:obj.brandname,spec:obj.spec});
    	}
    },
    
    /** 选择产品变更 */
    selectids(rel) {
    	for(let item of rel) this.changegoods(item);
    },
    /** 删除选中的产品 */
    deltempgoods(obj) {
    	const _this=this;
    	const oid=obj.id;
    	this.lists.goods.forEach(function(item,i) {
    		if(oid==item) {
    			_this.lists.goods.splice(i,1);
    			return false;	
    		}
    	});
    	
    	this.tempgoods.forEach(function(item,i) {
    		if(oid==item.id) {
    			_this.tempgoods.splice(i,1);
    			return false;
    		}
    	});
    },
    
    /** 获取品牌列表 */
    getBrand(){
      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:10}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    /** 查询使用商品 */
    getgoods() {
    	this.goodsLoading=true;
      	this.url=this.GLOBAL.domain+"Product/index";
      	this.lists.act='lists';
      	var resource = this.$resource(this.url);
      	resource.query(this.searchgoods).then((res) => {
      		if(res.data.Result>0){
          		if(res.data.Result=='70001'){
            		this.$router.push('/login');
            		this.goodsLoading = false;
          		}
          		this.$message.error(res.data.Message);
          		this.listLoading = false;
        	}else{
          		this.goodslists = JSON.parse(Base64.decode(res.data.Data));
          		this.goods_total_rows=parseInt(res.data.count);
          		this.goodsLoading = false;
        	}
      	}).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.goodsLoading = false;
      	});
    },
    
    /** 保存提成设置 */
    createPercentSave() {
        // 主动校验
        this.$refs.pct.validate((valid) => {
            if (valid) {
	            this.createLoading=true;
	            this.url=this.GLOBAL.domain+"Percent/index";
	            this.lists.act='addpercent';
	            var resource = this.$resource(this.url);
	            resource.save(this.lists).then((res) => {
	                if(res.data.Result>0){
		        	    if(res.data.Result=='70001') this.$router.push('/login');
		            	    this.$message.error(res.data.Message);
		            	    this.createLoading=false;
		                }else{
		            	    this.$message.success(res.data.Message);
		                    this.createPercent=false;
		                    this.createLoading=false;
		                    this.percentsearch();
		                }
	            }).catch((res) => {
	            	this.$message.error(this.GLOBAL.errortext);
	            	this.createPercent=false;
	            	this.createLoading=false;
	            });
           }else {
               return false;
           }
        });  
    },
    
    /** 添加提成设置 */
    addpercentsetting() {
    	this.$emit('listenchild',{name:'新增提成设置',url:'Percentadd'});
    
    	//重置数组信息
    	/**
    	this.lists.id='';
    	this.lists.name='';
    	this.lists.detail=[];
    	this.lists.goods=[];
    	this.lists.min_price=[];
    	this.lists.max_price=[];
    	this.lists.percent=[];
    	this.lists.act='addpercent';
    	this.lists.click='createPercentSave';
    	this.ticheng=[{id:1}];
    	this.tempgoods=[];
    	this.getclerk();
    	this.createPercent=true; //开启添加提成设置页面
    	*/
    },
    
    /** 获取职员信息 **/
    getclerk() {
      this.url=this.GLOBAL.domain+"Percent/index";
      var resource = this.$resource(this.url);
      resource.query({act:'getclerk',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.lists.type = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    /** 修改提成设置 */
    editpercent(obj) {
    	this.$emit('listenchild',{name:'编辑提成信息',url:'Percentedit',data:obj});
    	
    	/**
    	var _this=this;
        this.lists.act='editpercent';
        this.lists.click='editPercentSave';
        this.lists.goods=[];
        this.lists.min_price=[];
        this.lists.max_price=[];
        this.lists.percent=[];
        this.ticheng=[];
        this.tempgoods=[];
        this.numb=0;
        this.createPercent=true;
        
        var resource = this.$resource(this.url);
      	resource.query({act:'getpercentdetail',token:this.$cookies.get('token'),id:obj.id}).then((res) => {
      		if(res.data.Result>0){
          		if(res.data.Result=='70001'){
            		this.$router.push('/login');
            		this.goodsLoading = false;
          		}
          		this.$message.error(res.data.Message);
          		this.listLoading = false;
        	}else{
          		this.editgoods = JSON.parse(Base64.decode(res.data.Data));
          		this.lists.id=this.editgoods.id;
          		this.lists.name=this.editgoods.name;
          		this.lists.type=this.editgoods.type;
          		this.lists.goods=this.editgoods.goods_ids;
          		this.tempgoods=[];
          		
          		this.editgoods.min_price.forEach(function(item,i) {
          			_this.numb=i+1;
          			_this.ticheng.push({id:_this.numb});
    				_this.lists.min_price.push(item);
    			});
          		
          		this.editgoods.max_price.forEach(function(item,i) {
    				_this.lists.max_price.push(item);
    			});
    			
    			this.editgoods.percent.forEach(function(item,i) {
    				_this.lists.percent.push(item);
    			});
    			
    			this.editgoods.goodslists.forEach(function(item,i) {
    				_this.tempgoods.push({id:item.id,name:item.name,brandname:item.brandname,spec:item.spec});
    			});
        	}
      	}).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.goodsLoading = false;
      	});
      	*/
    },
    
    /** 修改保存提成设置 */
    editPercentSave() {
    	this.createLoading=true;
    	this.lists.act='saveeditpercent';
    	this.lists.goods_ids=this.lists.goods.join(",");
    	this.url=this.GLOBAL.domain+"Percent/index";
        var resource = this.$resource(this.url);
        resource.save(this.lists).then((res) => {
        	if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login');
	            this.$message.error(res.data.Message);
	            this.createLoading=false;
	        }else{
	        	this.$message.success(res.data.Message);
	            this.createPercent=false;
	            this.createLoading=false;
	            this.percentsearch();
	        }
        }).catch((res) => {
        	alert('报错了');
        	this.$message.error(this.GLOBAL.errortext);
            this.createPercent=false;
            this.createLoading=false;
        });
    },
    
    /**删除提成设置*/
    deletepercent(obj) {
    	this.$confirm('此操作将永久删除 ' + obj.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
              this.url=this.GLOBAL.domain+"Percent/index";
              var resource = this.$resource(this.url);
              resource.save({ act:'deletepercent',id: obj.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login');
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + obj.name + '!');
                    this.percentsearch();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
              });
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
    },
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Percent.vue